import styled from 'styled-components';
import { BaseFormSelect } from 'components/Form/FormSelect';
import DefaultButton from 'components/Buttons/Button';

// TODO: TFR-44 move to container group or do not export
export const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  grid-gap: 1.5rem;
  margin-bottom: 2rem;
`;

// TODO: TFR-46 remove imports in styled.ts if you do not add styles to component
export const Select = styled(BaseFormSelect)``;

// TODO: TFR-46 remove imports in styled.ts if you do not add styles to component
export const Button = styled(DefaultButton)``;
